import { Coins, Plus } from "lucide-react";
import { useNavigate } from "react-router-dom";

export function CreditBalance({ credits = null, plan = "free", compact = false }) {
  const navigate = useNavigate();
  const loaded = credits !== null && credits !== undefined;
  const low = loaded && credits < 20;
  return (
    <button
      data-testid="credit-balance-widget"
      onClick={() => navigate("/app/billing")}
      className="inline-flex items-center gap-2 rounded-full border px-3 py-1.5 hover:border-amber-500/40 transition-colors"
      style={low ? { borderColor: "rgba(245,158,11,0.5)" } : {}}
    >
      <Coins className="h-4 w-4 text-amber-400" />
      <span className="font-mono text-sm font-semibold text-white">{loaded ? credits : "—"}</span>
      {!compact && <span className="text-xs text-slate-500">{!loaded ? "" : low ? "· saldo bajo" : "créditos"}</span>}
      <span className="ml-1 flex h-5 w-5 items-center justify-center rounded-full bg-amber-500/15 text-amber-400">
        <Plus className="h-3 w-3" />
      </span>
    </button>
  );
}
